import {MessageDescriptor} from '@lingui/core';
import {t} from '@lingui/macro';

/*
 * Types.
 */

export enum RuleEditorConditionBaseErrorsEnum {
  NO_CONDITIONS = 'NO_CONDITIONS',
  INVALID_CONDITION = 'INVALID_CONDITION',
}

export enum RuleEditorActionBaseErrorsEnum {
  NO_ACTION = 'NO_ACTION',
  INVALID_ACTION = 'INVALID_ACTION',
}

export enum RuleEditorTriggerBaseErrorsEnum {
  NO_TRIGGER = 'NO_TRIGGER',
  INVALID_TRIGGER = 'INVALID_TRIGGER',
}

/*
 * Constants.
 */

export const ruleEditorConditionBaseErrorLabels: Record<
  RuleEditorConditionBaseErrorsEnum,
  MessageDescriptor
> = {
  [RuleEditorConditionBaseErrorsEnum.NO_CONDITIONS]: t(
    'rule-editor-footer-tooltip-warning-missing-condition',
  )`Condition is required`,
  [RuleEditorConditionBaseErrorsEnum.INVALID_CONDITION]: t(
    'rule-editor-footer-tooltip-warning-invalid-condition',
  )`One of your If conditions is invalid`,
};

export const ruleEditorActionBaseErrorLabels: Record<RuleEditorActionBaseErrorsEnum, MessageDescriptor> = {
  [RuleEditorActionBaseErrorsEnum.NO_ACTION]: t(
    'rule-editor-footer-tooltip-warning-missing-action',
  )`Action is required`,
  [RuleEditorActionBaseErrorsEnum.INVALID_ACTION]: t(
    'rule-editor-footer-tooltip-warning-invalid-action',
  )`One of your Then actions is invalid`,
};

export const ruleEditorTriggerBaseErrorLabels: Record<RuleEditorTriggerBaseErrorsEnum, MessageDescriptor> = {
  [RuleEditorTriggerBaseErrorsEnum.NO_TRIGGER]: t(
    'rule-editor-footer-tooltip-warning-missing-trigger',
  )`Trigger is required`,
  [RuleEditorTriggerBaseErrorsEnum.INVALID_TRIGGER]: t(
    'rule-editor-footer-tooltip-warning-invalid-trigger',
  )`One of your When triggers is invalid`,
};
